module.exports = __webpack_public_path__ + "static/media/countdown-title.c269125c.png";